import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

export default function useQBankStructureActivityLogSearchParams() {
  return useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    field: parseAsString.withDefault('actionTime'),
    sort: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
  });
}
